import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { SITE, whatsappLink } from "@/lib/site";

export default function StickyCTA() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => setVisible(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 transition-transform duration-300 ${
        visible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      <div className="grid grid-cols-3 bg-foreground-950/95 backdrop-blur-md border-t border-background-700/40">
        <a
          href={`tel:${SITE.phone}`}
          className="flex flex-col items-center gap-0.5 py-2.5 text-background-50 text-xs font-medium"
        >
          <i className="ri-phone-fill text-lg text-primary-400" />
          <span>Call</span>
        </a>
        <a
          href={whatsappLink("Hi! I'd like to book a ride in Los Angeles.")}
          target="_blank"
          rel="noopener noreferrer"
          className="flex flex-col items-center gap-0.5 py-2.5 text-background-50 text-xs font-medium border-x border-background-700/40"
        >
          <i className="ri-whatsapp-fill text-lg text-primary-400" />
          <span>WhatsApp</span>
        </a>
        <Link
          to="/#reservation"
          className="flex flex-col items-center gap-0.5 py-2.5 bg-primary-500 text-background-50 text-xs font-semibold"
        >
          <i className="ri-calendar-check-fill text-lg" />
          <span>Book Now</span>
        </Link>
      </div>
    </div>
  );
}
